import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, PieSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsPieChartProps,
    EchartsPieFormData,
    PieChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { getLegendObject } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsPieChartProps,
): PieChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      tooltipFormat,
      labelAlignment,
      labelPosition,
      showLegend,
      legendOrientation,
      legendMargin
    }: EchartsPieFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    const seriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });
      return {
        name: label,
        value: datum[metricLabel]
      };
    });
  
    const series: PieSeriesOption[] = [
      {
        name: metricLabel,
        type: 'pie',
        radius: '50%',
        animation: true,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          position: labelPosition,
          alignTo: labelAlignment
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      legend: {...getLegendObject(showLegend, legendOrientation,
        legendMargin ? legendMargin.toString() : undefined)},
      tooltip: {
        trigger: 'item',
        formatter: tooltipFormat
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  